import { render, staticRenderFns } from "./IconCheckSolvency.vue?vue&type=template&id=1f4ab7ae&"
import script from "./IconCheckSolvency.vue?vue&type=script&lang=js&"
export * from "./IconCheckSolvency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports